import React, { forwardRef } from 'react'
import { useTheme } from '@/hooks/useTheme'

export interface BaseInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onChangeText?: (text: string) => void
}

export const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  ({ onChangeText, onChange, ...props }, ref) => {
    const theme = useTheme()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e)
      onChangeText?.(e.target.value)
    }

    return (
      <input
        ref={ref}
        onChange={handleChange}
        style={{
          backgroundColor: theme.colors.background.textInput,
          color: theme.colors.label.textTextInput,
          border: 'none',
          outline: 'none',
          ...props.style,
        }}
        {...props}
      />
    )
  },
)

BaseInput.displayName = 'BaseInput'
